export const getCellWidth = ({ isHoverStartDate, isInRange, isHoverEndDate }) => {
    if (isHoverStartDate && isHoverEndDate) {
        return '';
    }
    if (isInRange) {
        return 'twds-w-10';
    }
    return '';
};
export const getCellMargin = ({ isHoverStartDate, isInRange, isHoverEndDate }) => {
    if (isHoverStartDate && isHoverEndDate) {
        return '';
    }
    if (isHoverStartDate) {
        return 'twds-mr-[-0.75rem]';
    }
    if (isHoverEndDate) {
        return 'twds-ml-[-0.75rem]';
    }
    if (isInRange) {
        return 'twds-mx-[-0.375rem]';
    }
    return '';
};
export const getCellAlignment = ({ isHoverStartDate, isInRange, isHoverEndDate }) => {
    if (isHoverStartDate && isHoverEndDate) {
        return '';
    }
    if (isHoverStartDate) {
        return 'twds-justify-start';
    }
    if (isHoverEndDate) {
        return 'twds-justify-end';
    }
    if (isInRange) {
        return 'twds-justify-center';
    }
    return '';
};
export const getCellBGColor = ({ isInRange }) => {
    if (isInRange) {
        return 'twds-bg-blue-200 dark:twds-bg-gray-800';
    }
    return '';
};
export const getCellRadius = ({ isHoverStartDate, isHoverEndDate, isStartDate, isEndDate }) => {
    if (isStartDate || isEndDate || (isHoverStartDate && isHoverEndDate)) {
        return 'twds-rounded-full';
    }
    if (isHoverStartDate) {
        return 'twds-rounded-l-full';
    }
    if (isHoverEndDate) {
        return 'twds-rounded-r-full';
    }
    return '';
};
export const getContainerBGColor = ({ isStartDate, isEndDate, isSelected, focus }) => {
    if (isStartDate || isEndDate || isSelected) {
        return 'twds-bg-blue-600 dark:twds-bg-blue-700';
    }
    if (focus) {
        return 'twds-bg-white dark:twds-bg-black';
    }
    return '';
};
export const getContainerRadius = ({ isStartDate, isEndDate, isSelected, focus }) => {
    if (isStartDate || isEndDate || isSelected || focus) {
        return 'twds-rounded-full';
    }
    return '';
};
export const getContainerBorder = ({ isStartDate, isEndDate, focus, isSelected }) => {
    if (isStartDate || isEndDate || isSelected) {
        return '';
    }
    if (focus) {
        return 'twds-box-border twds-border-solid twds-border-blue-600 dark:twds-border-blue-400';
    }
    return '';
};
export const getTextColor = ({ isCurrentMonth, isDisabled, isStartDate, isSelected, isEndDate }) => {
    if (isDisabled) {
        return 'twds-text-gray-400 dark:text-gray-600';
    }
    if (!isCurrentMonth) {
        return 'twds-text-gray-500 dark:text-gray-500';
    }
    if (isStartDate || isEndDate || isSelected) {
        return 'twds-text-white';
    }
    return 'twds-text-primary dark:twds-text-white';
};
//# sourceMappingURL=day.logic.js.map